import axiosCommon from '../helper/axiosCommon'
import qs from 'qs'


async function updateOne(permission) {
  const req = axiosCommon.getAxiosParamsAuth(`/permissions/${permission.id}`, 'put', permission)
  return await axiosCommon.axiosRequest(req)
}

async function deleteOne(id) {
  const req = axiosCommon.getAxiosParamsAuth(`/permissions/${id}`, 'delete')
  return await axiosCommon.axiosRequest(req)
}

async function createOne(permission) {
  const req = axiosCommon.getAxiosParamsAuth('/permissions', 'post', permission)
  return await axiosCommon.axiosRequest(req)
}

async function readPaginated(query) {
  const req = axiosCommon.getAxiosParamsAuth('/permissions?' + qs.stringify(query), 'get')
  return await axiosCommon.axiosRequest(req)
}

async function readList() {
  const req = axiosCommon.getAxiosParamsAuth('/permissions-list', 'get')
  return await axiosCommon.axiosRequest(req)
}


export default {
  updateOne,
  deleteOne,
  createOne,
  readPaginated,
  readList
}


